module.exports = __webpack_public_path__ + "static/media/A-sharp-Triads.1bce202d.png";